import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
//import PropTypes from 'prop-types';
import Login from './Login';
import Dashboard from './Dashboard';
import AdminPage from './AdminPage';
import AdminManageUsersPage from './AdminManageUsersPage';
import PartExceptionsPage from './PartExceptionsPage';
import PartSeasonsPage from './PartSeasonsPage';
import VendorOrderPage from './VendorOrderPage';
import InventoryShapingPage from './InventoryShapingPage';
import PartLookupPage from './PartLookupPage';
import ReportsDataPage from './ReportsDataPage';
import ReportsListingPage from './ReportsListingPage';
import RegisterPage from './RegisterPage';
import ChangePasswordPage from './ChangePasswordPage';
import NotFound from './NotFound';
import StandardLayout from '../containers/StandardLayout';
import OrgGroupPage from './OrgGroupPage';
import SupportPage from './SupportPage';
import Test from './Test';
import Callback from './Callback';
import { AppContext } from '../context/AppContext';
import { decodeJwtToken, convertEpochToDate, isEmpty } from '../helpers';
import queryString from "query-string";
import localize from '../hoc/localize';
import BookingsListingPage from './BookingReturnsListingPage';
import BookingsPage from './BookingReturnsPage';
import BookingReturnsPage from './BookingReturnsPage';



class Router extends React.Component {

    isSuperAdmin = () => {
        const { roles } = this.context.state;
        return (!isEmpty(roles) && roles.includes("superadmin"));
    }


    isLoggedIn = () => {
        // criteria:
        // must be valid JWT token
        // can't be expired
        // orgType must be defined

        const accessTokenString = this.context.state.accessToken;
        const idTokenString = this.context.state.idToken;
        const orgType = this.context.state.orgType;

        let allowUser = false;

        // get the access token
        if (accessTokenString && idTokenString && decodeJwtToken(idTokenString) && orgType) {
            const accessToken = decodeJwtToken(accessTokenString);

            // get expiry date
            if (accessToken) {
                const expiryDate = convertEpochToDate(accessToken.exp);


                allowUser = (expiryDate > new Date());
            }
        }

        return allowUser;

    };


    render() {

        //!DBTRANS! @m0381@ Admin reports !DEVNOTE! Title
        //!DBTRANS! @m0382@ Admin - Manage Users !DEVNOTE! Title

        return (
            <React.Fragment>

                <BrowserRouter>
                    <React.Fragment>

                        <Switch>
                            <Route exact path="/" component={Login} />

                            <Route path="/callback" render={() => <Callback />} />;
                            <Route path="/dashboard" render={() => (
                                this.isLoggedIn() ? <StandardLayout><Dashboard /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route path="/inventory-shaping" render={() => (
                                this.isLoggedIn() ? <StandardLayout><InventoryShapingPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route path="/suggested-order/:orgVendorID/type/:orderType/suggestions" render={(props) => {

                                let vals = queryString.parse(props.location.search);
                                let vendorName;
                                if (vals) {
                                    if (!isEmpty(vals["vendorName"])) {
                                        vendorName = vals["vendorName"];
                                    }
                                };
                                return ((this.isLoggedIn()) ? <StandardLayout><VendorOrderPage mode="suggestedPO" orderType={props.match.params.orderType} orgVendorID={props.match.params.orgVendorID} vendorName={vendorName} /></StandardLayout> : <Redirect to="/" />);

                            }} />
                            <Route key="suggestedOrderVendors" path="/suggested-order/type/:orderType" render={(props) => {

                                // // get orderType from querystring parameter
                                // const queryStringParams = queryString.parse(props.location.search)
                                // let orderType = 0
                                // if (queryStringParams.orderType) {
                                //     orderType = queryStringParams.orderType

                                // }
                                //console.log('reloading route')

                                return (
                                    this.isLoggedIn() ? <StandardLayout><VendorOrderPage mode="vendors" orderType={props.match.params.orderType} /></StandardLayout> : <Redirect to="/" />
                                )
                            }} />


                            <Route path="/parts" render={() => (
                                this.isLoggedIn() ? <StandardLayout><PartLookupPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact key="normalReports" path="/reports/:reportType" render={(props) => {
                                //debugger;
                                return (

                                    this.isLoggedIn() ? <StandardLayout><ReportsDataPage mode="normalReports" /></StandardLayout> : <Redirect to="/" />
                                );
                            }
                            } />

                            <Route exact key="bookingReturns" path="/booking-returns/:reportType" render={(props) => {
                                //debugger;
                                return (

                                    this.isLoggedIn() ? <StandardLayout><BookingsPage mode={"booking"}/></StandardLayout> : <Redirect to="/" />
                                );
                            }
                            } />

                            <Route exact key="editPartsBooking" path="/booking-returns/parts-booking-history/edit-parts-booking" render={(props) => {
                                //debugger;
                                return (

                                    this.isLoggedIn() ? <StandardLayout><BookingReturnsPage mode={"editBooking"} {...props} /></StandardLayout> : <Redirect to="/" />
                                );
                            }
                            } />

                            <Route exact key="adminReports" path="/admin/reports/:reportType" render={(props) => {
                                //debugger;
                                let role = '';
                                let roleID = '';
                                const queryStringParams = queryString.parse(props.location.search);
                                if (queryStringParams.role) {
                                    role = queryStringParams.role;
                                };
                                if (queryStringParams.roleID) {
                                    roleID = queryStringParams.roleID
                                };
                                const roleObj = { roleID, role };

                                if (this.isLoggedIn())
                                    if (this.isSuperAdmin() && role === "superadmin" && roleID === "572180F3-3F48-4523-B547-2B134FCB05CF")
                                        return (
                                            <StandardLayout><ReportsDataPage mode="adminReports" role={roleObj} /></StandardLayout>
                                        );
                                    else
                                        return (
                                            <StandardLayout><ReportsDataPage /></StandardLayout>
                                        );
                                else
                                    return (<Redirect to="/" />);
                            }} />

                            <Route exact key="bookingReturns" path="/booking-returns" render={() => (
                                this.isLoggedIn() ? <StandardLayout><BookingsListingPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact key="normalReports" path="/reports" render={() => (
                                this.isLoggedIn() ? <StandardLayout><ReportsListingPage mode="normalReports" /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact key="adminReports" path="/admin/reports" render={(props) => {
                                let role = '';
                                let roleID = '';
                                const queryStringParams = queryString.parse(props.location.search);
                                if (queryStringParams.role) {
                                    role = queryStringParams.role;
                                };
                                if (queryStringParams.roleID) {
                                    roleID = queryStringParams.roleID
                                };
                                const roleObj = { roleID, role };

                                if (this.isLoggedIn())
                                    if (this.isSuperAdmin() && role === "superadmin" && roleID === "572180F3-3F48-4523-B547-2B134FCB05CF")
                                        return (
                                            <StandardLayout title={this.props.returnLocalizedString("m0381")}><ReportsListingPage mode="adminReports" role={roleObj} /></StandardLayout>
                                        );
                                    else
                                        return (
                                            <StandardLayout><ReportsListingPage /></StandardLayout>
                                        );
                                else
                                    return (<Redirect to="/" />);
                            }} />

                            <Route path="/settings/report-groups" render={() => (
                                this.isLoggedIn() ? <StandardLayout><OrgGroupPage /></StandardLayout> : <Redirect to="/" />
                            )} />



                            <Route exact path="/support" render={() => (
                                this.isLoggedIn() ? <StandardLayout><SupportPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact path="/admin" render={() => (
                                this.isLoggedIn() && this.isSuperAdmin() ? <StandardLayout><AdminPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact key="manageUsersForOwnOrg" path="/settings/users" render={(props) => {
                                // check if we have an orgID yet
                                const { orgID, orgName } = this.context.state;
                                const org = { orgID, orgName }

                                if (this.isLoggedIn() && orgID && orgName) {

                                    return (<StandardLayout>
                                        <AdminManageUsersPage mode="manageUsersForOwnOrg" org={org} />
                                    </StandardLayout>)
                                } else {
                                    return <Redirect to="/" />
                                }
                            }} />

                            <Route path="/settings/part-exceptions" render={() => (
                                this.isLoggedIn() ? <StandardLayout><PartExceptionsPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route path="/settings/part-seasons" render={() => (
                                this.isLoggedIn() ? <StandardLayout><PartSeasonsPage /></StandardLayout> : <Redirect to="/" />
                            )} />

                            <Route exact key="manageUsersForSelectedOrg" path="/admin/org/:orgID/users" render={(props) => {
                                // this screen is for bringing up a list of users for a given norg

                                // get orgName from querystring parameter
                                const orgID = props.match.params.orgID;
                                let orgName = '';
                                const queryStringParams = queryString.parse(props.location.search)
                                if (queryStringParams.orgName) {
                                    orgName = queryStringParams.orgName
                                }
                                const org = { orgID, orgName }

                                return (
                                    this.isLoggedIn() && this.isSuperAdmin() ? <StandardLayout title={this.props.returnLocalizedString("m0382")}><AdminManageUsersPage mode="manageUsersForSelectedOrg" org={org} /></StandardLayout> : <Redirect to="/" />
                                )
                            }} />

                            <Route exact key="manageSuperAdmins" path="/admin/org/users" render={(props) => {
                                // this screen is for managing superadmins 

                                let role = '';
                                let roleID = '';
                                const queryStringParams = queryString.parse(props.location.search);
                                if (queryStringParams.role) {
                                    role = queryStringParams.role;
                                }
                                if (queryStringParams.roleID) {
                                    roleID = queryStringParams.roleID
                                }
                                const roleObj = { roleID, role }

                                return (
                                    this.isLoggedIn() && this.isSuperAdmin() ? <StandardLayout title={this.props.returnLocalizedString("m0382")}><AdminManageUsersPage mode="manageSuperAdmins" role={roleObj} /></StandardLayout> : <Redirect to="/" />
                                )
                            }} />

                            <Route path="/register/:registrationGuid" render={(props) => (
                                <RegisterPage registrationGuid={props.match.params.registrationGuid} />
                            )} />

                            <Route path="/change-password" render={() => (
                                <ChangePasswordPage />
                            )} />

                            <Route path="/test" render={() => (
                                <Test />
                            )} />

                            <Route component={NotFound} />

                        </Switch>
                    </React.Fragment>
                </BrowserRouter>

            </React.Fragment>
        );
    }


};

export default localize(Router);

Router.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/containers/Router.js